module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/logo_user_way-ab65147884a45aff7ba7c50bd6117218.svg";